import { CakeSlice, MessageCircle, ClipboardCheck, Truck, CalendarDays, HandCoins, MapPin } from "lucide-react";
import { WHATSAPP_URL } from "@/constants";
import { WhatsAppIcon } from "@/components/icons";
import Seo from "@/components/Seo";

const STEPS = [
  { icon: CakeSlice, title: "Escolhe o teu doce" },
  { icon: MessageCircle, title: "Envia-nos uma mensagem" },
  { icon: ClipboardCheck, title: "Confirma os detalhes e o orçamento" },
  { icon: Truck, title: "Combina a recolha ou entrega" },
];

const NOTES = [
  {
    icon: CalendarDays,
    text: "As encomendas devem ser feitas, preferencialmente, com uma antecedência mínima de 5 dias e ficam confirmadas após validação da disponibilidade.",
  },
  {
    icon: HandCoins,
    text: "Os preços são fornecidos sob consulta, de acordo com o tamanho, recheio, cobertura e decoração escolhidos.",
  },
  {
    icon: MapPin,
    text: "Estamos na Amadora. Fazemos entregas na Amadora, Grande Lisboa e arredores, mediante disponibilidade e confirmação do valor da entrega.",
  },
];

export default function Encomendar() {
  return (
    <>
      <Seo
        title="Como encomendar | Doce Casa"
        siteName="Doce Casa"
        description="Encomenda os teus bolos e sobremesas artesanais pelo WhatsApp. Entregas na Amadora, Grande Lisboa e arredores. Preços sob consulta."
      />

      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-16 md:py-24" data-testid="order-page">
        <div className="text-center animate-rise">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-chocolate">
            Como encomendar
          </h1>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-cocoa max-w-2xl mx-auto">
            Escolhe o teu doce e envia-nos uma mensagem pelo WhatsApp com o
            produto pretendido, a data da encomenda, o número aproximado de
            pessoas e a decoração ou personalização desejada.
          </p>
        </div>

        <ol className="mt-14 grid gap-6 sm:grid-cols-2">
          {STEPS.map((step, i) => (
            <li
              key={step.title}
              data-testid={`order-step-${i + 1}`}
              className="relative bg-white rounded-3xl border border-sand p-7 shadow-[0_14px_35px_-18px_rgba(61,35,20,0.25)] animate-rise"
              style={{ animationDelay: `${0.1 + i * 0.1}s` }}
            >
              <span className="absolute top-5 right-6 font-hand text-4xl text-caramel/40" aria-hidden="true">
                {i + 1}
              </span>
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-beige border border-sand">
                <step.icon className="w-6 h-6 text-caramel" aria-hidden="true" />
              </span>
              <h2 className="mt-4 font-serif text-xl font-semibold text-chocolate">
                {step.title}
              </h2>
            </li>
          ))}
        </ol>

        <div className="mt-14 space-y-4">
          {NOTES.map((note) => (
            <div key={note.text.slice(0, 20)} className="flex gap-4 items-start bg-beige rounded-2xl border border-sand p-5">
              <note.icon className="w-5 h-5 mt-0.5 shrink-0 text-terracotta" aria-hidden="true" />
              <p className="text-sm sm:text-base leading-relaxed text-cocoa">{note.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="order-whatsapp-btn"
            className="inline-flex items-center justify-center gap-3 rounded-full bg-caramel px-10 py-5 text-lg font-medium text-cream shadow-lg transition-all duration-200 hover:bg-caramel-dark hover:shadow-xl hover:-translate-y-0.5"
          >
            <WhatsAppIcon className="w-6 h-6" />
            Pedir pelo WhatsApp
          </a>
        </div>
      </section>
    </>
  );
}
